import { VNTAXES_FETCH_TAXES_SUCCEEDED } from './ActionTypes'

const getInitialState = () => {
  return {
    taxClasses: {},
    taxRules: {},
  }
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case VNTAXES_FETCH_TAXES_SUCCEEDED:
      const taxClasses = action.payload.taxClasses
      const taxRules = action.payload.taxRules

      return {
        ...state,
        taxClasses,
        taxRules,
      }

    default:
      return state
  }
}

export default reducer
